import { LocalizedString } from "interfaces/common";
import { IntlShape } from "react-intl";

export const translate = (intl: IntlShape, id: string, values?: { [key: string]: any }) =>
    intl.formatMessage({ id }, values);

export const getLocalizedString = (locale: string, localizedString?: LocalizedString): string =>
    localizedString?.[locale as keyof LocalizedString] || "";
